<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-if="formParam.id!='' && formParam.id!=null">Edit Operator</h5>
          <h5 class="modal-title" v-else>Tambah Operator</h5>
          <!-- {{broadcastParam.broadcast_id}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- {{formParam}} -->
          <!-- {{formParamOperatorSt}} -->
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-sm-6 col-md-6">
                          <div class="form-group">
                            <label>
                              Internal Name:
                              <span class="text-danger">*</span>
                            </label>
                            <input
                              v-model="formParam.internal_name"
                              placeholder="John Doe..."
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <div class="form-group">
                            <label>
                              Public Name:
                              <span class="text-danger">*</span>
                            </label>
                            <input
                              v-model="formParam.public_name"
                              placeholder="CS - John Doe..."
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6 col-md-6">
                          <div class="form-group">
                            <label>
                              Whatsapp Number:
                              <span class="text-danger">*</span>
                            </label>
                            <input
                              v-model="formParam.phone_number"
                              placeholder="6281234567890..."
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <div class="form-group">
                            <label>
                              Role Name:
                              <span class="text-danger">*</span>
                            </label>
                            <input
                              v-model="formParam.role_name"
                              placeholder="Customer Support..."
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12 col-md-12">
                          <div class="form-group">
                            <label>
                              Greeting Message:
                              <span class="text-danger">*</span>
                            </label>
                            <input
                              v-model="formParam.greeting_message"
                              placeholder="Halo, ada yang bisa dibantu?..."
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Attach Photo</label>
                          <p v-if="formParam.photo!=''">
                            <a target="_blank" :href="formParam.photo">
                              <img :src="formParam.photo" style="width:100px;" />
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <div v-show="files.length==0" class="col-md-12 upload-drop-zone" id="drop-zone">
                      <center>
                        <i class="fa fa-cloud-upload fa-2x"></i>
                        <span class="upload-text">
                          <label :for="name">
                            Just drag and
                            drop image here
                          </label>
                        </span>
                      </center>
                    </div>
                    <div>
                      <div class="col-md-12">
                        <!-- {{files}} -->
                        <!-- <h4 v-if="files.length">Uploading</h4> -->
                        <ul class="upload-list" v-if="files.length">
                          <li v-for="file in files" :key="file.id" class="file-list">
                            <div class="upload-wrap">
                              <div class="file-name">
                                <!-- <i class="fa fa-photo"></i> -->
                                <img style="width:30px;" v-if="file.thumb" :src="file.thumb" />
                                {{file.name}}
                              </div>
                              <div class="file-size">{{formatSizes(file.size)}}</div>
                              <div class="file-close">
                                <span class="text-danger" v-if="file.error">{{file.error}}</span>
                                <span v-else-if="file.success">
                                  <i class="text-success fa fa-check-circle"></i>
                                </span>
                                <span v-else-if="file.active">active</span>
                                <span v-else></span>

                                <a
                                  href="#"
                                  @click.prevent="$refs.uploadbc.remove(file)"
                                  class="text-warning"
                                >
                                  <i class="fa fa-trash-o"></i>
                                </a>
                              </div>
                            </div>

                            <div
                              class="progress progress-xs progress-striped"
                              v-if="file.active || file.progress !== '0.00'"
                            >
                              <div
                                class="progress-bar bg-success"
                                role="progressbar"
                                :style="{width: file.progress + '%'}"
                              ></div>
                            </div>
                            <div
                              class="upload-process"
                              v-if="file.active || file.progress !== '0.00'"
                            >{{file.progress}}% done</div>
                          </li>
                        </ul>
                      </div>
                      <!-- </form> -->

                      <div class="col-sm-12 col-md-12">
                        <div class="alert alert-info">
                          <ul style=" overflow-x: scroll;overflow-y: hidden;white-space:nowrap;">
                            <li class="text-wrap">Support files: {{extensions}}</li>
                            <li>MaxSize: 1Mb</li>
                          </ul>
                        </div>
                      </div>
                      <div
                        class="col-sm-12"
                        v-show="($refs.uploadbc && $refs.uploadbc.active==false)"
                      >
                        <div class="submit-section">
                          <div class="input-group mb-3">
                            <div class="input-group-prepend" v-show="false">
                              <file-upload-bc
                                :add-index="true"
                                class="btn btn-outline-secondary"
                                :data="objFilesMessageHandler"
                                :post-action="uploadUrl"
                                :multiple="false"
                                :headers="headers"
                                :drop="true"
                                :drop-directory="true"
                                v-model="files"
                                @input-filter="inputFilter"
                                @input-file="inputFile"
                                ref="uploadbc"
                                :maximum="maximumUpload"
                                :extensions="extensions"
                              >
                                <img src="@/assets/attachment.png" alt />
                              </file-upload-bc>
                            </div>

                            <div class="input-group-append">
                              <button
                                v-if="false"
                                @click.prevent="$refs.uploadbc.active = true"
                                class="btn btn-outline-secondary"
                                type="button"
                              >Upload File</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row" v-if="$refs.uploadbc && $refs.uploadbc.active==true">
                        <div class="col-sm-2">
                          <Skeleton :height="'40px'" :count="1" />
                        </div>
                        <div class="col-sm-2">
                          <Skeleton :height="'40px'" :count="1" />
                        </div>
                        <div class="col-sm-6">
                          <Skeleton :height="'40px'" :count="1" />
                        </div>
                        <div class="col-sm-2">
                          <Skeleton :height="'40px'" :count="1" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Set Working Hours</label>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="onoffswitch">
                        <input
                          type="checkbox"
                          name="onoffswitch"
                          class="onoffswitch-checkbox"
                          v-model="formParam.is_scheduling"
                          id="switch_footer_message"
                        />
                        <label class="onoffswitch-label" for="switch_footer_message">
                          <span class="onoffswitch-inner"></span>
                          <span class="onoffswitch-switch"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12" v-if="formParam.is_scheduling==1">
                  <div class="row">
                    <div class="col-md-12">
                      <table class="table table-striped custom-table mb-0">
                        <thead>
                          <tr>
                            <th>Day</th>
                            <th>Open Time</th>
                            <th>Close Time</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template>
                            <tr>
                              <td>Monday</td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_monday_start_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_monday_start_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <select style="width:50px;" v-model="formParam.wh_monday_end_hour">
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_monday_end_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <div class="form-group">
                                  <div class="onoffswitch">
                                    <input
                                      type="checkbox"
                                      name="onoffswitch"
                                      v-model="formParam.wh_monday_status"
                                      class="onoffswitch-checkbox"
                                      id="wh_monday_status"
                                    />
                                    <label class="onoffswitch-label" for="wh_monday_status">
                                      <span class="onoffswitch-inner"></span>
                                      <span class="onoffswitch-switch"></span>
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Tuesday</td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_tuesday_start_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_tuesday_start_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <select style="width:50px;" v-model="formParam.wh_tuesday_end_hour">
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_tuesday_end_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <div class="form-group">
                                  <div class="onoffswitch">
                                    <input
                                      type="checkbox"
                                      name="onoffswitch"
                                      v-model="formParam.wh_tuesday_status"
                                      class="onoffswitch-checkbox"
                                      id="wh_tuesday_status"
                                    />
                                    <label class="onoffswitch-label" for="wh_tuesday_status">
                                      <span class="onoffswitch-inner"></span>
                                      <span class="onoffswitch-switch"></span>
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Wednesday</td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_wednesday_start_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_wednesday_start_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_wednesday_end_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_wednesday_end_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <div class="form-group">
                                  <div class="onoffswitch">
                                    <input
                                      type="checkbox"
                                      name="onoffswitch"
                                      v-model="formParam.wh_wednesday_status"
                                      class="onoffswitch-checkbox"
                                      id="wh_wednesday_status"
                                    />
                                    <label class="onoffswitch-label" for="wh_wednesday_status">
                                      <span class="onoffswitch-inner"></span>
                                      <span class="onoffswitch-switch"></span>
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Thursday</td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_thursday_start_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_thursday_start_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_thursday_end_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_thursday_end_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <div class="form-group">
                                  <div class="onoffswitch">
                                    <input
                                      type="checkbox"
                                      name="onoffswitch"
                                      v-model="formParam.wh_thursday_status"
                                      class="onoffswitch-checkbox"
                                      id="wh_thursday_status"
                                    />
                                    <label class="onoffswitch-label" for="wh_thursday_status">
                                      <span class="onoffswitch-inner"></span>
                                      <span class="onoffswitch-switch"></span>
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Friday</td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_friday_start_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_friday_start_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <select style="width:50px;" v-model="formParam.wh_friday_end_hour">
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_friday_end_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <div class="form-group">
                                  <div class="onoffswitch">
                                    <input
                                      type="checkbox"
                                      name="onoffswitch"
                                      v-model="formParam.wh_friday_status"
                                      class="onoffswitch-checkbox"
                                      id="wh_friday_status"
                                    />
                                    <label class="onoffswitch-label" for="wh_friday_status">
                                      <span class="onoffswitch-inner"></span>
                                      <span class="onoffswitch-switch"></span>
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Saturday</td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_saturday_start_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_saturday_start_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_saturday_end_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_saturday_end_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <div class="form-group">
                                  <div class="onoffswitch">
                                    <input
                                      type="checkbox"
                                      name="onoffswitch"
                                      v-model="formParam.wh_saturday_status"
                                      class="onoffswitch-checkbox"
                                      id="wh_saturday_status"
                                    />
                                    <label class="onoffswitch-label" for="wh_saturday_status">
                                      <span class="onoffswitch-inner"></span>
                                      <span class="onoffswitch-switch"></span>
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Sunday</td>
                              <td>
                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_sunday_start_hour"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_sunday_start_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <select style="width:50px;" v-model="formParam.wh_sunday_end_hour">
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="hour in 23"
                                    :key="hour"
                                    :value="(hour<10)?'0'+hour:hour"
                                  >{{(hour<10)?'0'+hour:hour}}</option>
                                </select>

                                <select
                                  style="width:50px;"
                                  v-model="formParam.wh_sunday_end_minute"
                                >
                                  <option :value="''">--</option>
                                  <option :value="'00'">00</option>
                                  <option
                                    v-for="minute in 59"
                                    :key="minute"
                                    :value="(minute<10)?'0'+minute:minute"
                                  >{{(minute<10)?'0'+minute:minute}}</option>
                                </select>
                              </td>
                              <td>
                                <div class="form-group">
                                  <div class="onoffswitch">
                                    <input
                                      type="checkbox"
                                      name="onoffswitch"
                                      v-model="formParam.wh_sunday_status"
                                      class="onoffswitch-checkbox"
                                      id="wh_sunday_status"
                                    />
                                    <label class="onoffswitch-label" for="wh_sunday_status">
                                      <span class="onoffswitch-inner"></span>
                                      <span class="onoffswitch-switch"></span>
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="submit-section">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <!-- {{isSending}} -->
                    <button @click="saveForm(0,1)" class="btn btn-md btn-warning" type="button">
                      <i class="fa fa-save"></i> Draft
                    </button>

                    <button
                      @click.prevent="saveForm(0,0)"
                      class="btn btn-md btn-success"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-check"></i> Publish
                    </button>
                  </center>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <button
                      @click.prevent="saveForm(1,0)"
                      class="btn btn-lg btn-info"
                      type="button"
                    >
                      <i class="fa fa-check"></i> Publish &amp; Exit
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import PreviewMessage from "./preview";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Datetime,
    PreviewMessage
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        message_type: ""
      },
      messageTypeOptionsSupport: ["text only", "media"],
      uploadMessageSupportSelected: "text only",
      messageTypeOptionsUpload: ["image", "document"],
      uploadMessageType: "image",
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/omni/only-upload-filev2",
      maximumUpload: 1,
      accept: "image/jfif,image/png,image/gif,image/jpeg,image/webp",
      extensions: "jfif, gif,jpg,jpeg,png,webp",
      minSize: 1024,
      size: 1024 * 1024 * 2,
      files: [],
      buttonsLoading: false,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsRows: [],
      linkRows: [],
      selectedLicense: [],
      licenseOptions: [],
      licenseListParam: {
        id: "",
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoadingLicense: false,
      emojiAttr2: {
        open: false,
        width: "0%",
        height: "0px"
      },
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}"
      ],
      isSending: false,
      defaultDetailButton: 10,
      defaultDetailListText: 10, //max 10
      formParam: {
        id: "",
        internal_name: "",
        public_name: "",
        role_name: "",
        phone_number: "",
        greeting_message: "",
        photo: "",
        is_scheduling: 0,
        is_publish: 0,
        wh_sunday_status: 0,
        wh_sunday_start: "08:00",
        wh_sunday_start_hour: "08",
        wh_sunday_start_minute: "00",
        wh_sunday_end: "17:00",
        wh_sunday_end_hour: "17",
        wh_sunday_end_minute: "00",
        wh_monday_status: 0,
        wh_monday_start: "08:00",
        wh_monday_start_hour: "08",
        wh_monday_start_minute: "00",
        wh_monday_end: "17:00",
        wh_monday_end_hour: "17",
        wh_monday_end_minute: "00",
        wh_tuesday_status: 0,
        wh_tuesday_start: "08:00",
        wh_tuesday_start_hour: "08",
        wh_tuesday_start_minute: "00",
        wh_tuesday_end: "17:00",
        wh_tuesday_end_hour: "17",
        wh_tuesday_end_minute: "00",
        wh_wednesday_status: 0,
        wh_wednesday_start: "08:00",
        wh_wednesday_start_hour: "08",
        wh_wednesday_start_minute: "00",
        wh_wednesday_end: "17:00",
        wh_wednesday_end_hour: "17",
        wh_wednesday_end_minute: "00",
        wh_thursday_status: 0,
        wh_thursday_start: "08:00",
        wh_thursday_start_hour: "08",
        wh_thursday_start_minute: "00",
        wh_thursday_end: "17:00",
        wh_thursday_end_hour: "17",
        wh_thursday_end_minute: "00",
        wh_friday_status: 0,
        wh_friday_start: "08:00",
        wh_friday_start_hour: "08",
        wh_friday_start_minute: "00",
        wh_friday_end: "17:00",
        wh_friday_end_hour: "17",
        wh_friday_end_minute: "00",
        wh_saturday_status: 0,
        wh_saturday_start: "08:00",
        wh_saturday_start_hour: "08",
        wh_saturday_start_minute: "00",
        wh_saturday_end: "17:00",
        wh_saturday_end_hour: "17",
        wh_saturday_end_minute: "00"
      },
      isLoading: false
    };
  },
  watch: {
    isShowForm: {
      handler: async function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          this.selectedLicense = [];
          this.buttonsRows = [];
          this.linkRows = [];
          var that = this;
          setTimeout(async function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamOperatorSt.id != "" &&
              that.formParamOperatorSt.id != null
            ) {
              if (
                typeof that.formParamOperatorSt.copy != "undefined" &&
                that.formParamOperatorSt.copy == true
              ) {
                that.formParamOperatorSt.id = "";
              }

              that.formParam = that.formParamOperatorSt;

              // console.log("that.formParam", that.formParam);
            } else {
              that.formParam = await {
                id: "",
                internal_name: "",
                public_name: "",
                role_name: "",
                phone_number: "",
                greeting_message: "",
                photo: "",
                is_scheduling: 0,
                is_publish: 0,
                wh_sunday_status: 0,
                wh_sunday_start: "08:00",
                wh_sunday_start_hour: "08",
                wh_sunday_start_minute: "00",
                wh_sunday_end: "17:00",
                wh_sunday_end_hour: "17",
                wh_sunday_end_minute: "00",
                wh_monday_status: 0,
                wh_monday_start: "08:00",
                wh_monday_start_hour: "08",
                wh_monday_start_minute: "00",
                wh_monday_end: "17:00",
                wh_monday_end_hour: "17",
                wh_monday_end_minute: "00",
                wh_tuesday_status: 0,
                wh_tuesday_start: "08:00",
                wh_tuesday_start_hour: "08",
                wh_tuesday_start_minute: "00",
                wh_tuesday_end: "17:00",
                wh_tuesday_end_hour: "17",
                wh_tuesday_end_minute: "00",
                wh_wednesday_status: 0,
                wh_wednesday_start: "08:00",
                wh_wednesday_start_hour: "08",
                wh_wednesday_start_minute: "00",
                wh_wednesday_end: "17:00",
                wh_wednesday_end_hour: "17",
                wh_wednesday_end_minute: "00",
                wh_thursday_status: 0,
                wh_thursday_start: "08:00",
                wh_thursday_start_hour: "08",
                wh_thursday_start_minute: "00",
                wh_thursday_end: "17:00",
                wh_thursday_end_hour: "17",
                wh_thursday_end_minute: "00",
                wh_friday_status: 0,
                wh_friday_start: "08:00",
                wh_friday_start_hour: "08",
                wh_friday_start_minute: "00",
                wh_friday_end: "17:00",
                wh_friday_end_hour: "17",
                wh_friday_end_minute: "00",
                wh_saturday_status: 0,
                wh_saturday_start: "08:00",
                wh_saturday_start_hour: "08",
                wh_saturday_start_minute: "00",
                wh_saturday_end: "17:00",
                wh_saturday_end_hour: "17",
                wh_saturday_end_minute: "00"
              };
              await that.detailWorkingHours();
              that.formParam.id = await "";
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken()
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    ...mapGetters(["agentSession"]),
    formParamOperatorSt() {
      return this.$store.state.toolkit.formParamOperatorSt;
    },
    isShowForm() {
      return this.$store.state.toolkit.isShowForm;
    }
  },
  methods: {
    async detailWorkingHours() {
      let formData = await {};
      await this.$store
        .dispatch("toolkit/detailWorkingHours") // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          // this.formOld = data;
          this.formParam = data;
          console.log(data);
        });
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    async saveForm(isExit = 0, isDraft = 0) {
      if (typeof isDraft == "undefined") {
        this.formParam.is_publish = 1;
      } else {
        if (isDraft == 1) {
          this.formParam.is_publish = 0;
        } else {
          this.formParam.is_publish = 1;
        }
      }
      this.formParam.create_datetime = new Date();
      this.formParam.update_datetime = new Date();
      this.formParam.member_id = parseInt(this.formParam.member_id);

      this.formParam.is_scheduling = this.formParam.is_scheduling ? 1 : 0;

      this.formParam.wh_sunday_status = this.formParam.wh_sunday_status ? 1 : 0;
      this.formParam.wh_sunday_start =
        this.formParam.wh_sunday_start_hour +
        ":" +
        this.formParam.wh_sunday_start_minute;
      this.formParam.wh_sunday_end =
        this.formParam.wh_sunday_end_hour +
        ":" +
        this.formParam.wh_sunday_end_minute;

      this.formParam.wh_monday_status = this.formParam.wh_monday_status ? 1 : 0;
      this.formParam.wh_monday_start =
        this.formParam.wh_monday_start_hour +
        ":" +
        this.formParam.wh_monday_start_minute;
      this.formParam.wh_monday_end =
        this.formParam.wh_monday_end_hour +
        ":" +
        this.formParam.wh_monday_end_minute;

      this.formParam.wh_tuesday_status = this.formParam.wh_tuesday_status
        ? 1
        : 0;
      this.formParam.wh_tuesday_start =
        this.formParam.wh_tuesday_start_hour +
        ":" +
        this.formParam.wh_tuesday_start_minute;
      this.formParam.wh_tuesday_end =
        this.formParam.wh_tuesday_end_hour +
        ":" +
        this.formParam.wh_tuesday_end_minute;

      this.formParam.wh_wednesday_status = this.formParam.wh_wednesday_status
        ? 1
        : 0;
      this.formParam.wh_wednesday_start =
        this.formParam.wh_wednesday_start_hour +
        ":" +
        this.formParam.wh_wednesday_start_minute;
      this.formParam.wh_wednesday_end =
        this.formParam.wh_wednesday_end_hour +
        ":" +
        this.formParam.wh_wednesday_end_minute;

      this.formParam.wh_thursday_status = this.formParam.wh_thursday_status
        ? 1
        : 0;
      this.formParam.wh_thursday_start =
        this.formParam.wh_thursday_start_hour +
        ":" +
        this.formParam.wh_thursday_start_minute;
      this.formParam.wh_thursday_end =
        this.formParam.wh_thursday_end_hour +
        ":" +
        this.formParam.wh_thursday_end_minute;

      this.formParam.wh_friday_status = this.formParam.wh_friday_status ? 1 : 0;
      this.formParam.wh_friday_start =
        this.formParam.wh_friday_start_hour +
        ":" +
        this.formParam.wh_friday_start_minute;
      this.formParam.wh_friday_end =
        this.formParam.wh_friday_end_hour +
        ":" +
        this.formParam.wh_friday_end_minute;

      this.formParam.wh_saturday_status = this.formParam.wh_saturday_status
        ? 1
        : 0;
      this.formParam.wh_saturday_start =
        this.formParam.wh_saturday_start_hour +
        ":" +
        this.formParam.wh_saturday_start_minute;
      this.formParam.wh_saturday_end =
        this.formParam.wh_saturday_end_hour +
        ":" +
        this.formParam.wh_saturday_end_minute;
      console.log("formParam", this.formParam);
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;

          await this.$store
            .dispatch("toolkit/storeOperator", this.formParam)
            .then(async response => {
              this.files = [];
              // this.isSending = false;
              if (this.formParam.id == "") {
                this.formParam = {
                  id: "",
                  internal_name: "",
                  public_name: "",
                  role_name: "",
                  phone_number: "",
                  greeting_message: "",
                  photo: "",
                  is_scheduling: 0,
                  is_publish: 0,
                  wh_sunday_status: 0,
                  wh_sunday_start: "08:00",
                  wh_sunday_start_hour: "08",
                  wh_sunday_start_minute: "00",
                  wh_sunday_end: "17:00",
                  wh_sunday_end_hour: "17",
                  wh_sunday_end_minute: "00",
                  wh_monday_status: 0,
                  wh_monday_start: "08:00",
                  wh_monday_start_hour: "08",
                  wh_monday_start_minute: "00",
                  wh_monday_end: "17:00",
                  wh_monday_end_hour: "17",
                  wh_monday_end_minute: "00",
                  wh_tuesday_status: 0,
                  wh_tuesday_start: "08:00",
                  wh_tuesday_start_hour: "08",
                  wh_tuesday_start_minute: "00",
                  wh_tuesday_end: "17:00",
                  wh_tuesday_end_hour: "17",
                  wh_tuesday_end_minute: "00",
                  wh_wednesday_status: 0,
                  wh_wednesday_start: "08:00",
                  wh_wednesday_start_hour: "08",
                  wh_wednesday_start_minute: "00",
                  wh_wednesday_end: "17:00",
                  wh_wednesday_end_hour: "17",
                  wh_wednesday_end_minute: "00",
                  wh_thursday_status: 0,
                  wh_thursday_start: "08:00",
                  wh_thursday_start_hour: "08",
                  wh_thursday_start_minute: "00",
                  wh_thursday_end: "17:00",
                  wh_thursday_end_hour: "17",
                  wh_thursday_end_minute: "00",
                  wh_friday_status: 0,
                  wh_friday_start: "08:00",
                  wh_friday_start_hour: "08",
                  wh_friday_start_minute: "00",
                  wh_friday_end: "17:00",
                  wh_friday_end_hour: "17",
                  wh_friday_end_minute: "00",
                  wh_saturday_status: 0,
                  wh_saturday_start: "08:00",
                  wh_saturday_start_hour: "08",
                  wh_saturday_start_minute: "00",
                  wh_saturday_end: "17:00",
                  wh_saturday_end_hour: "17",
                  wh_saturday_end_minute: "00"
                };
                await this.detailWorkingHours();
                this.formParam.id = await "";
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.formParam.header.message += args.emoji;
      // console.log(args); /* return {...}*/
    },

    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    updateMessageTypeCurrent(msgType) {
      if (msgType == "") {
        var that = this;
        setTimeout(function() {
          // console.log(
          //   "that.formParam.header.is_enable_attach_file",
          //   that.formParam.header.is_enable_attach_file
          // );
          if (that.formParam.header.is_enable_attach_file == true) {
            that.formParam.header.message_type = "image";
            that.uploadMessageType = that.formParam.header.message_type;
            // that.formParam.header.is_custom_url = false;
            // console.log("that.uploadMessageTyp",that.uploadMessageType)
          } else {
            that.formParam.header.message_type = "text";
          }
        }, 100);
      } else {
        this.uploadMessageType = msgType;
        this.formParam.header.message_type = msgType;
      }
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => {});
        }
        if (newFile.success && !oldFile.success) {
          this.formParam.photo = newFile.response.data.url;
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.formParam.photo = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/toolkit/operator/form.vue